import {profCollaborator} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';
import {useSelector} from 'react-redux';

function useLoadProfCollaborator(additional?: string | null) {
  let object = undefined;
  if (additional != null) {
    object = {additional};
  }
  return useLoad(profCollaborator, ['employee_Nr', 'iD_ProfileSpac'], object);
}

export function useLoadProfCollaboratorWithFilters(
  key: string,
  idInstance?: number,
  idCourse?: number,
) {
  const filters = useSelector((state: any) => state.gridReducer.filters);
  const additional =
    key === 'selectAll'
      ? JSON.stringify({Key: 'selectAll'})
      : JSON.stringify({
          Key: 'AddInstance',
          Value: idInstance,
          id_course: idCourse,
        });
  let object = {additional};
  let options = new URLSearchParams();
  options.append('filter', JSON.stringify(filters));
  return useLoad(
    `${profCollaborator}?${options}`,
    ['employee_Nr', 'iD_ProfileSpac'],
    object,
  );
}

export default useLoadProfCollaborator;
